
import axios from 'axios';
import { ROOT_API_URL } from '../../api-config';
import { history } from '../../helpers/history';

export const CREATE_ACCOUNT_SUCCESS = 'CREATE_ACCOUNT_SUCCESS';
export const CREATE_ACCOUNT_ERROR = 'CREATE_ACCOUNT_ERROR';
export const CREATE_ACCOUNT_REQUEST = 'CREATE_ACCOUNT_REQUEST';

export const createAccount = (email, password) => {
    return (dispatch) => {
        dispatch({
            type: CREATE_ACCOUNT_REQUEST,
            payload: email
        });
        var m = { Email: email, Password: password };
        
        axios.post(`${ROOT_API_URL}/account/register`, m)
            .then(res => {
                if (res && res.data && res.data.isSuccess){
                    dispatch({
                        type: CREATE_ACCOUNT_SUCCESS,
                        payload: email
                    });
                    history.push('/registerConfirmation');
                }else{
                    dispatch({
                        type: CREATE_ACCOUNT_ERROR,
                        payload: res.data.message
                    });
                    // history.push('/registerError');
                }
            }, error => {
                dispatch({
                    type: CREATE_ACCOUNT_ERROR,
                    payload: "Error occured"
                });
                history.push('/registerError');                
            });
    }
}
